import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMinusLarge"><Path d="M3.5 12H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMinusLarge;
